import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import socket from '../../utils/socket';
import './Controller.scss';

const Controller = () => {
    const { codePartie } = useParams();
    const navigate = useNavigate();

    const [player, setPlayer] = useState(null);
    const [mode, setMode] = useState('WAITING');
    const [question, setQuestion] = useState(null);
    const [texteBouton, setTexteBouton] = useState("Continuer");
    const [availablePlayers, setAvailablePlayers] = useState([]);

    const [joinCodeInput, setJoinCodeInput] = useState("");
    const [pseudoInput, setPseudoInput] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    const playerRef = useRef(null);

    useEffect(() => {
        playerRef.current = player;
    }, [player]);

    useEffect(() => {
        if (!codePartie) return;

        console.log("✅ Manette en écoute pour la partie :", codePartie);

        const stored = sessionStorage.getItem(`currentPlayer_${codePartie}`);
        if (stored) {
            const parsed = JSON.parse(stored);
            socket.emit('joueur_choisi', { codePartie, playerId: parsed.id }, (response) => {
                if (response && response.success) {
                    setPlayer(response.player);
                }
            });
        } else {
            socket.emit('rejoindre_partie', codePartie);
            socket.emit('demande_liste_joueurs', codePartie);
        }

        const handleListeJoueurs = (playersData) => {
            setAvailablePlayers(playersData);
        };

        const handleActionRequise = (data) => {
            const currentPlayer = playerRef.current;

            if (data.action === 'BUZZER') {
                setMode('BUZZER');
            } else if (currentPlayer && String(data.playerId) === String(currentPlayer.id)) {
                if (data.action === 'CONTINUE') {
                    setMode('CONTINUE');
                    setTexteBouton(data.texteBoutonManette || "Continuer");
                } else {
                    setMode(data.action);
                    if (data.question) setQuestion(data.question);
                }
            } else {
                setMode('WAITING');
            }
        };

        const handlePartieRelancee = () => {
            setMode('WAITING');
            setQuestion(null);
        };

        const handlePartieAnnulee = (data) => {
            alert(data?.message || "La partie a été annulée car un joueur a fermé son navigateur.");
            sessionStorage.removeItem(`currentPlayer_${codePartie}`);
            navigate('/');
        };

        socket.on('liste_joueurs', handleListeJoueurs);
        socket.on('action_requise', handleActionRequise);
        socket.on('partie_relancee', handlePartieRelancee);
        socket.on('partie_annulee', handlePartieAnnulee);

        return () => {
            socket.off('liste_joueurs', handleListeJoueurs);
            socket.off('action_requise', handleActionRequise);
            socket.off('partie_relancee', handlePartieRelancee);
            socket.off('partie_annulee', handlePartieAnnulee);
        };
    }, [codePartie, navigate]);

    const validerCode = () => {
        if (joinCodeInput.trim().length === 6) {
            setErrorMsg("");
            navigate(`/controller/${joinCodeInput.trim().toUpperCase()}`);
        } else {
            setErrorMsg("Veuillez saisir un code à 6 caractères.");
        }
    };

    const rejoindreNouveauJoueur = () => {
        if (socket && codePartie && pseudoInput.trim()) {
            setErrorMsg("");
            socket.emit('rejoindre_partie_nom', { codePartie, name: pseudoInput.trim() }, (response) => {
                if (response && response.success) {
                    setPlayer(response.player);
                    sessionStorage.setItem(`currentPlayer_${codePartie}`, JSON.stringify(response.player));
                } else if (response && response.error) {
                    setErrorMsg(response.error);
                } else {
                    setErrorMsg("Impossible de rejoindre cette partie.");
                }
            });
        }
    };

    const choisirJoueur = (p) => {
        if (socket && codePartie) {
            setErrorMsg("");
            socket.emit('joueur_choisi', { codePartie, playerId: p.id }, (response) => {
                if (response && response.success) {
                    setPlayer(response.player);
                    sessionStorage.setItem(`currentPlayer_${codePartie}`, JSON.stringify(response.player));
                } else if (response && response.error) {
                    setErrorMsg(response.error);
                } else {
                    setErrorMsg("Impossible de sélectionner ce joueur.");
                }
            });
        }
    };

    const envoyerLancerDe = () => {
        socket.emit('lancer_de', { codePartie, playerId: player.id });
        setMode('WAITING');
    };

    const envoyerBuzzer = () => {
        const audio = new Audio('/Sound/buzzer.mp3');
        audio.play().catch(error => console.log("Erreur son buzzer :", error));
        socket.emit('buzzer_presse', { codePartie, playerId: player.id });
        setMode('WAITING');
    };

    const envoyerReponse = (texteReponse) => {
        socket.emit('reponse_choisie', { codePartie, playerId: player.id, reponse: texteReponse });
        setMode('WAITING');
    };

    const envoyerContinuer = () => {
        socket.emit('clic_continuer', { codePartie, playerId: player.id });
        setMode('WAITING');
    };

    // --- SÉCURITÉ POUR LES OPTIONS DE RÉPONSE ---
    let optionsArray = [];
    if (question) {
        try {
            optionsArray = typeof question.options === 'string' 
                ? JSON.parse(question.options) 
                : (question.options || []);
        } catch (error) {
            console.error("Erreur parsing options manette :", error);
            // Fallback si la BDD utilise l'ancien format choixA, choixB
            if (question.choixA) {
                optionsArray = [question.choixA, question.choixB, question.choixC, question.choixD].filter(Boolean);
            }
        }
    }

    if (!codePartie) {
        return (
            <div className="controller-selection">
                {/* ... (Code d'interface d'accueil inchangé) ... */}
                <h2>Manette de Jeu</h2>
                <div className="player-grid">
                    <div className="form-group" style={{ width: '100%' }}>
                        <input
                            type="text"
                            placeholder="CODE PARTIE (ex: XOEUKR)"
                            value={joinCodeInput}
                            onChange={(e) => setJoinCodeInput(e.target.value.toUpperCase())}
                            maxLength={6}
                            style={{ width: '100%', padding: '15px', borderRadius: '10px', border: '1px solid #444', backgroundColor: '#222', color: 'white', fontSize: '1.2rem', textAlign: 'center', letterSpacing: '2px', boxSizing: 'border-box' }}
                        />
                    </div>
                    {errorMsg && <p style={{ color: '#ff4d4d', textAlign: 'center', margin: '10px 0' }}>{errorMsg}</p>}
                    <button onClick={validerCode} style={{ backgroundColor: '#3b82f6', color: 'white', padding: '15px', borderRadius: '10px', border: 'none', fontWeight: 'bold', fontSize: '1.1rem', cursor: 'pointer' }}>Suivant ➡️</button>
                </div>
            </div>
        );
    }

    if (!player) {
        const vraisJoueurs = availablePlayers.filter(p => p.name.trim() !== '');
        return (
            <div className="controller-selection">
                {/* ... (Code de sélection de joueur inchangé) ... */}
                <h2>Rejoindre la partie</h2>
                <strong style={{ color: '#3b82f6', fontSize: '1.8rem', marginBottom: '20px', letterSpacing: '1px' }}>{codePartie}</strong>
                <div className="player-grid" style={{ width: '100%', maxWidth: '320px' }}>
                    <div style={{ width: '100%', borderBottom: '1px solid #333', paddingBottom: '20px', marginBottom: '10px' }}>
                        <input type="text" placeholder="Votre Pseudo (ex: Bob)" value={pseudoInput} onChange={(e) => setPseudoInput(e.target.value)} style={{ width: '100%', padding: '12px 18px', borderRadius: '10px', border: '1px solid #444', backgroundColor: '#222', color: 'white', fontSize: '1rem', marginBottom: '12px', boxSizing: 'border-box' }} />
                        <button onClick={rejoindreNouveauJoueur} disabled={!pseudoInput.trim() || availablePlayers.length >= 4} style={{ width: '100%', backgroundColor: '#10b981', color: 'white', padding: '12px', borderRadius: '10px', border: 'none', fontWeight: 'bold', fontSize: '1rem', cursor: 'pointer', opacity: (!pseudoInput.trim() || availablePlayers.length >= 4) ? 0.5 : 1 }}>{availablePlayers.length >= 4 ? "Partie Pleine 🛑" : "Rejoindre la partie 🎮"}</button>
                    </div>
                    {vraisJoueurs.length > 0 && (
                        <div style={{ width: '100%', marginTop: '10px' }}>
                            <p style={{ textAlign: 'center', color: '#888', fontSize: '0.9rem', marginBottom: '15px' }}>Ou contrôler un profil déjà en jeu :</p>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                {vraisJoueurs.map(p => (
                                    <button key={p.id} style={{ backgroundColor: p.color, opacity: p.connected ? 0.4 : 1, color: 'white', fontWeight: 'bold', padding: '12px', borderRadius: '10px', border: 'none', fontSize: '1rem', cursor: p.connected ? 'not-allowed' : 'pointer' }} onClick={() => !p.connected && choisirJoueur(p)} disabled={p.connected}>{p.name} {p.connected ? ' (Pris)' : ''}</button>
                                ))}
                            </div>
                        </div>
                    )}
                    {errorMsg && <p style={{ color: '#ff4d4d', textAlign: 'center', marginTop: '15px' }}>{errorMsg}</p>}
                </div>
            </div>
        );
    }

    return (
        <div className="controller-main" style={{ backgroundColor: player.color }}>
            <header className="controller-header">
                <span className="player-name">{player.name}</span>
            </header>

            <main className="controller-body">
                {mode === 'WAITING' && (
                    <div className="status-message">
                        <h2>Regarde l'écran principal</h2>
                        <p>En attente de ton tour...</p>
                    </div>
                )}

                {mode === 'ROLL' && (
                    <button className="btn-action roll" onClick={envoyerLancerDe}>
                        Lancer 🎲
                    </button>
                )}

                {mode === 'BUZZER' && (
                    <button className="btn-buzzer" onClick={envoyerBuzzer}>
                        BUZZ !
                    </button>
                )}

                {/* CORRECTION ICI : Boucle dynamique sur les options */}
                {mode === 'ANSWER' && question && optionsArray.length > 0 && (
                    <div className="answers-list">
                        {optionsArray.map((option, index) => (
                            <button key={index} onClick={() => envoyerReponse(option)}>
                                {String.fromCharCode(65 + index)}. {option}
                            </button>
                        ))}
                    </div>
                )}

                {mode === 'CONTINUE' && (
                    <button className="btn-action continue" onClick={envoyerContinuer}>
                        {texteBouton}
                    </button>
                )}
            </main>
        </div>
    );
};

export default Controller;